import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "toast-content" }
const _hoisted_2 = { class: "toast-text" }
const _hoisted_3 = { class: "toast-title" }
const _hoisted_4 = { class: "toast-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.show) = $event)),
    color: _ctx.model.color,
    timeout: 5000,
    location: "top right",
    class: "modern-toast",
    elevation: "8"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["toast-icon-wrapper", `toast-${_ctx.model.color}`])
        }, [
          _createVNode(_component_v_icon, {
            color: _ctx.model.iconColor,
            size: "20"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.model.icon), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ], 2),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.model.title), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.snackbar.message), 1)
        ]),
        _createVNode(_component_v_btn, {
          icon: "",
          size: "small",
          variant: "text",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show = false)),
          class: "toast-close"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-close", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "color"]))
}